import { render } from "./PrimeiraConferencia.vue?vue&type=template&id=250e6e1c&scoped=true"
import script from "./PrimeiraConferencia.vue?vue&type=script&lang=js"
export * from "./PrimeiraConferencia.vue?vue&type=script&lang=js"

import "./PrimeiraConferencia.vue?vue&type=style&index=0&id=250e6e1c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250e6e1c"]])

export default __exports__